import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { reduce } from "lodash";

import { useGetTagsQuery } from "~/features/collections/forms/CreateCollectionMultistepForm/tags-categories/queries.graphql.generated";

const useTags = (search: string, isFocused: boolean) => {
  const enableTags = useFeatureFlags(FEATURE_FLAGS.ENABLE_TAGS_AND_CATEGORIES);
  const { data, loading } = useGetTagsQuery({
    variables: {
      search: search || null,
      cursor: null,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-first",
    skip:
      !enableTags ||
      !isFocused ||
      (search != null && search.length > 0 && search.length <= 3),
  });
  const tagsSearched = data?.getTags.tags || [];

  const getSlug = (name: string) => {
    const formattedName = name
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // remove accents
      .replace(/[^a-z0-9]/g, "-") // Replace no alphanumeric chars
      .replace(/-+/g, "-") // Replace multiple dash with only one
      .replace(/^-|-$/g, ""); // Remove first and final dash

    const hash = reduce(
      formattedName,
      (hash, char) => {
        return (hash << 5) - hash + char.charCodeAt(0);
      },
      0
    );

    const shortHash = Math.abs(hash).toString(36).substring(0, 4);

    if (formattedName === name) {
      return formattedName;
    }

    return `${formattedName}-${shortHash}`;
  };

  return {
    tagsSearched,
    enableTags,
    getSlug,
    loading,
  };
};

export default useTags;
